import { render, staticRenderFns } from "./PopupAddMissingData.vue?vue&type=template&id=98248d28&"
import script from "./PopupAddMissingData.vue?vue&type=script&lang=js&"
export * from "./PopupAddMissingData.vue?vue&type=script&lang=js&"
import style0 from "./PopupAddMissingData.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports